import { useSyncExternalStore } from 'react'
import { isElectron } from '../utils/platform.js'

let fullScreen = false
const listeners = new Set()

function subscribe(callback) {
  listeners.add(callback)
  return () => listeners.delete(callback)
}

function getSnapshot() {
  return fullScreen
}

// Single IPC listener shared across all hook instances
if (typeof window !== 'undefined' && isElectron() && window.electronAPI?.onFullscreenChange) {
  window.electronAPI.onFullscreenChange((value) => {
    fullScreen = value
    listeners.forEach(fn => fn())
  })
}

export function useFullscreen() {
  return useSyncExternalStore(subscribe, getSnapshot)
}
